/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/texas-bathroom-bill-annotated/scripts/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _preact = __webpack_require__(6);
	
	var _adLoader = __webpack_require__(18);
	
	var _adLoader2 = _interopRequireDefault(_adLoader);
	
	var _relatedStories = __webpack_require__(16);
	
	var _relatedStories2 = _interopRequireDefault(_relatedStories);
	
	var _select = __webpack_require__(26);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _selectAll = __webpack_require__(7);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	__webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import './utils/ga-scroll-depth';
	
	var annotationNavBtns = (0, _selectAll2.default)('.js-nav-annotation');
	
	annotationNavBtns.forEach(function (btn) {
	  var id = btn.getAttribute('href');
	  var parentEl = (0, _select2.default)(id).parentNode.parentNode;
	
	  btn.addEventListener('click', function (e) {
	    e.preventDefault();
	
	    window.scrollTo(0, parentEl.getBoundingClientRect().top + window.pageYOffset - 15);
	  });
	});
	
	(0, _preact.render)((0, _preact.h)(_relatedStories2.default, { tag: 'subject-bathroom-bill' }), document.getElementById('related-stories-container'));
	
	var adLoader = new _adLoader2.default();
	adLoader.init();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(2);
	var getAttributes = __webpack_require__(30);
	
	
	var utilities = {
	
	
	  /**
	   * Accepts default and user override fields and an optional tracker, hit
	   * filter, and target element and returns a single object that can be used in
	   * `ga('send', ...)` commands.
	   * @param {Object} defaultFields The default fields to return.
	   * @param {Object} userFields Fields set by the user to override the defaults.
	   * @param {Object} opt_tracker The tracker object to apply the hit filter to.
	   * @param {Function} opt_hitFilter A filter function that gets
	   *     called with the tracker model right before the `buildHitTask`. It can
	   *     be used to modify the model for the current hit only.
	   * @param {Element} opt_target If the hit originated from an interaction
	   *     with a DOM element, hitFilter is invoked with that element as the
	   *     second argument.
	   * @return {Object} The final fields object.
	   */
	  createFieldsObj: function(
	      defaultFields, userFields, opt_tracker, opt_hitFilter, opt_target) {
	
	    if (typeof opt_hitFilter == 'function') {
	      var originalBuildHitTask = opt_tracker.get('buildHitTask');
	      return {
	        buildHitTask: function(model) {
	          model.set(defaultFields, null, true);
	          model.set(userFields, null, true);
	          opt_hitFilter(model, opt_target);
	          originalBuildHitTask(model);
	        }
	      };
	    }
	    else {
	      return assign({}, defaultFields, userFields);
	    }
	  },
	
	
	  /**
	   * Retrieves the attributes from an DOM element and returns a fields object
	   * for all attributes matching the passed prefix string.
	   * @param {Element} element The DOM element to get attributes from.
	   * @param {string} prefix An attribute prefix. Only the attributes matching
	   *     the prefix will be returned on the fields object.
	   * @return {Object} An object of analytics.js fields and values
	   */
	  getAttributeFields: function(element, prefix) {
	    var attributes = getAttributes(element);
	    var attributeFields = {};
	
	    Object.keys(attributes).forEach(function(attribute) {
	
	      // The `on` prefix is used for event handling but isn't a field.
	      if (attribute.indexOf(prefix) === 0 && attribute != prefix + 'on') {
	
	        var value = attributes[attribute];
	
	        // Detects Boolean value strings.
	        if (value == 'true') value = true;
	        if (value == 'false') value = false;
	
	        var field = utilities.camelCase(attribute.slice(prefix.length));
	        attributeFields[field] = value;
	      }
	    });
	
	    return attributeFields;
	  },
	
	
	  domReady: function(callback) {
	    if (document.readyState == 'loading') {
	      document.addEventListener('DOMContentLoaded', function fn() {
	        document.removeEventListener('DOMContentLoaded', fn);
	        callback();
	      });
	    } else {
	      callback();
	    }
	  },
	
	
	  /**
	   * Accepts a function and returns a wrapped version of the function that is
	   * expected to be called elsewhere in the system. If it's not called
	   * elsewhere after the timeout period, it's called regardless. The wrapper
	   * function also prevents the callback from being called more than once.
	   * @param {Function} callback The function to call.
	   * @param {number} wait How many milliseconds to wait before invoking
	   *     the callback.
	   * @returns {Function} The wrapped version of the passed function.
	   */
	  withTimeout: function(callback, wait) {
	    var called = false;
	    var fn = function() {
	      if (!called) {
	        called = true;
	        callback();
	      }
	    };
	    setTimeout(fn, wait || 2000);
	    return fn;
	  },
	
	
	  /**
	   * Accepts a string containing hyphen or underscore word separators and
	   * converts it to camelCase.
	   * @param {string} str The string to camelCase.
	   * @return {string} The camelCased version of the string.
	   */
	  camelCase: function(str) {
	    return str.replace(/[\-\_]+(\w?)/g, function(match, p1) {
	      return p1.toUpperCase();
	    });
	  },
	
	
	  /**
	   * Capitalizes the first letter of a string.
	   * @param {string} str The input string.
	   * @return {string} The capitalized string
	   */
	  capitalize: function(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	  },
	
	
	  /**
	   * Indicates whether the passed variable is a JavaScript object.
	   * @param {*} value The input variable to test.
	   * @return {boolean} Whether or not the test is an object.
	   */
	  isObject: function(value) {
	    return typeof value == 'object' && value !== null;
	  },
	
	
	  /**
	   * Indicates whether the passed variable is a JavaScript array.
	   * @param {*} value The input variable to test.
	   * @return {boolean} Whether or not the value is an array.
	   */
	  isArray: Array.isArray || function(value) {
	    return Object.prototype.toString.call(value) === '[object Array]';
	  },
	
	
	  /**
	   * Accepts a value that may or may not be an array. If it is not an array,
	   * it is returned as the first item in a single-item array.
	   * @param {*} value The value to convert to an array if it is not.
	   * @return {Array} The array-ified value.
	   */
	  toArray: function(value) {
	    return utilities.isArray(value) ? value : [value];
	  }
	};
	
	module.exports = utilities;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var constants = __webpack_require__(5);
	var utilities = __webpack_require__(1);
	
	
	// Adds the dev ID to the list of dev IDs if any plugin is used.
	(window.gaDevIds = window.gaDevIds || []).push(constants.DEV_ID);
	
	
	/**
	 * Provides a plugin for use with analytics.js, accounting for the possibility
	 * that the global command queue has been renamed or not yet defined.
	 * @param {string} pluginName The plugin name identifier.
	 * @param {Function} pluginConstructor The plugin constructor function.
	 */
	module.exports = function providePlugin(pluginName, pluginConstructor) {
	  var gaAlias = window['GoogleAnalyticsObject'] || 'ga';
	  window[gaAlias] = window[gaAlias] || function() {
	    (window[gaAlias]['q'] = window[gaAlias]['q'] || []).push(arguments);
	  };
	
	  // Formally provides the plugin for use with analytics.js.
	  window[gaAlias]('provide', pluginName, pluginConstructor);
	
	  // Registers the plugin on the global gaplugins object.
	  window.gaplugins = window.gaplugins || {};
	  window.gaplugins[utilities.capitalize(pluginName)] = pluginConstructor;
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var constants = __webpack_require__(5);
	
	
	var plugins = {
	  CLEAN_URL_TRACKER: 1,
	  EVENT_TRACKER: 2,
	  IMPRESSION_TRACKER: 3,
	  MEDIA_QUERY_TRACKER: 4,
	  OUTBOUND_FORM_TRACKER: 5,
	  OUTBOUND_LINK_TRACKER: 6,
	  PAGE_VISIBILITY_TRACKER: 7,
	  SOCIAL_WIDGET_TRACKER: 8,
	  URL_CHANGE_TRACKER: 9
	};
	var PLUGIN_COUNT = 9;
	
	
	/**
	 * Converts a hexadecimal string to a binary string.
	 * @param {string} hex A hexadecimal numeric string.
	 * @return {string} a binary numeric string.
	 */
	function convertHexToBin(hex) {
	  return parseInt(hex || '0', 16).toString(2);
	}
	
	
	/**
	 * Converts a binary string to a hexadecimal string.
	 * @param {string} bin A binary numeric string.
	 * @return {string} a hexadecimal numeric string.
	 */
	function convertBinToHex(bin) {
	  return parseInt(bin || '0', 2).toString(16);
	}
	
	
	/**
	 * Adds leading zeros to a string if it's less than a minimum length.
	 * @param {string} str A string to pad.
	 * @param {number} len The minimum length of the string
	 * @return {string} The padded string.
	 */
	function padZeros(str, len) {
	  if (str.length < len) {
	    var toAdd = len - str.length;
	    while (toAdd) {
	      str = '0' + str;
	      toAdd--;
	    }
	  }
	  return str;
	}
	
	
	/**
	 * Accepts a binary numeric string and flips the digit from 0 to 1 at the
	 * specified index.
	 * @param {string} str The binary numeric string.
	 * @param {number} index The index to flip the bit.
	 * @return {string} The new binary string with the bit flipped on
	 */
	function flipBitOn(str, index) {
	  return str.substr(0, index) + 1 + str.substr(index + 1);
	}
	
	
	/**
	 * Accepts a tracker and a plugin index and flips the bit at the specified
	 * index on the tracker's usage parameter.
	 * @param {Object} tracker An analytics.js tracker.
	 * @param {number} pluginIndex The index of the plugin in the global list.
	 */
	function trackPlugin(tracker, pluginIndex) {
	  var usageHex = tracker.get(constants.USAGE_PARAM);
	  var usageBin = padZeros(convertHexToBin(usageHex), PLUGIN_COUNT);
	
	  // Flip the bit of the plugin being tracked.
	  usageBin = flipBitOn(usageBin, PLUGIN_COUNT - pluginIndex);
	
	  // Stores the modified usage string back on the tracker.
	  tracker.set(constants.USAGE_PARAM, convertBinToHex(usageBin));
	}
	
	
	/**
	 * Accepts a tracker and adds the current version to the version param.
	 * @param {Object} tracker An analytics.js tracker.
	 */
	function trackVersion(tracker) {
	  tracker.set(constants.VERSION_PARAM, constants.VERSION);
	}
	
	
	module.exports = {
	  track: function(tracker, plugin) {
	    trackVersion(tracker);
	    trackPlugin(tracker, plugin);
	  },
	  plugins: plugins
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	module.exports = {
	  VERSION: '1.0.0',
	  DEV_ID: 'i5iSjo',
	
	  VERSION_PARAM: '&_av',
	  USAGE_PARAM: '&_au',
	
	  NULL_DIMENSION: '(not set)'
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	!function(global, factory) {
	     true ? factory(exports) : 'function' == typeof define && define.amd ? define([ 'exports' ], factory) : factory(global.preact = global.preact || {});
	}(this, function(exports) {
	    function VNode(nodeName, attributes, children) {
	        this.nodeName = nodeName;
	        this.attributes = attributes;
	        this.children = children;
	        this.key = attributes && attributes.key;
	    }
	    function h(nodeName, attributes) {
	        var children, lastSimple, child, simple, i;
	        for (i = arguments.length; i-- > 2; ) stack.push(arguments[i]);
	        if (attributes && attributes.children) {
	            if (!stack.length) stack.push(attributes.children);
	            delete attributes.children;
	        }
	        while (stack.length) if ((child = stack.pop()) instanceof Array) for (i = child.length; i--; ) stack.push(child[i]); else if (null != child && child !== !0 && child !== !1) {
	            if ('number' == typeof child) child = String(child);
	            simple = 'string' == typeof child;
	            if (simple && lastSimple) children[children.length - 1] += child; else {
	                (children || (children = [])).push(child);
	                lastSimple = simple;
	            }
	        }
	        var p = new VNode(nodeName, attributes || void 0, children || EMPTY_CHILDREN);
	        if (options.vnode) options.vnode(p);
	        return p;
	    }
	    function extend(obj, props) {
	        if (props) for (var i in props) obj[i] = props[i];
	        return obj;
	    }
	    function clone(obj) {
	        return extend({}, obj);
	    }
	    function delve(obj, key) {
	        for (var p = key.split('.'), i = 0; i < p.length && obj; i++) obj = obj[p[i]];
	        return obj;
	    }
	    function isFunction(obj) {
	        return 'function' == typeof obj;
	    }
	    function isString(obj) {
	        return 'string' == typeof obj;
	    }
	    function hashToClassName(c) {
	        var str = '';
	        for (var prop in c) if (c[prop]) {
	            if (str) str += ' ';
	            str += prop;
	        }
	        return str;
	    }
	    function cloneElement(vnode, props) {
	        return h(vnode.nodeName, extend(clone(vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
	    }
	    function createLinkedState(component, key, eventPath) {
	        var path = key.split('.');
	        return function(e) {
	            var t = e && e.target || this, state = {}, obj = state, v = isString(eventPath) ? delve(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e, i = 0;
	            for (;i < path.length - 1; i++) obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
	            obj[path[i]] = v;
	            component.setState(state);
	        };
	    }
	    function enqueueRender(component) {
	        if (!component._dirty && (component._dirty = !0) && 1 == items.push(component)) (options.debounceRendering || defer)(rerender);
	    }
	    function rerender() {
	        var p, list = items;
	        items = [];
	        while (p = list.pop()) if (p._dirty) renderComponent(p);
	    }
	    function isFunctionalComponent(vnode) {
	        var nodeName = vnode && vnode.nodeName;
	        return nodeName && isFunction(nodeName) && !(nodeName.prototype && nodeName.prototype.render);
	    }
	    function buildFunctionalComponent(vnode, context) {
	        return vnode.nodeName(getNodeProps(vnode), context || EMPTY);
	    }
	    function isSameNodeType(node, vnode) {
	        if (isString(vnode)) return node instanceof Text;
	        if (isString(vnode.nodeName)) return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	        if (isFunction(vnode.nodeName)) return (node._componentConstructor ? node._componentConstructor === vnode.nodeName : !0) || isFunctionalComponent(vnode); else return;
	    }
	    function isNamedNode(node, nodeName) {
	        return node.normalizedNodeName === nodeName || toLowerCase(node.nodeName) === toLowerCase(nodeName);
	    }
	    function getNodeProps(vnode) {
	        var props = clone(vnode.attributes);
	        props.children = vnode.children;
	        var defaultProps = vnode.nodeName.defaultProps;
	        if (defaultProps) for (var i in defaultProps) if (void 0 === props[i]) props[i] = defaultProps[i];
	        return props;
	    }
	    function removeNode(node) {
	        var p = node.parentNode;
	        if (p) p.removeChild(node);
	    }
	    function setAccessor(node, name, old, value, isSvg) {
	        if ('className' === name) name = 'class';
	        if ('class' === name && value && 'object' == typeof value) value = hashToClassName(value);
	        if ('key' === name) ; else if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
	            if (!value || isString(value) || isString(old)) node.style.cssText = value || '';
	            if (value && 'object' == typeof value) {
	                if (!isString(old)) for (var i in old) if (!(i in value)) node.style[i] = '';
	                for (var i in value) node.style[i] = 'number' == typeof value[i] && !NON_DIMENSION_PROPS[i] ? value[i] + 'px' : value[i];
	            }
	        } else if ('dangerouslySetInnerHTML' === name) {
	            if (value) node.innerHTML = value.__html || '';
	        } else if ('o' == name[0] && 'n' == name[1]) {
	            var l = node._listeners || (node._listeners = {});
	            name = toLowerCase(name.substring(2));
	            if (value) {
	                if (!l[name]) node.addEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            } else if (l[name]) node.removeEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            l[name] = value;
	        } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
	            setProperty(node, name, null == value ? '' : value);
	            if (null == value || value === !1) node.removeAttribute(name);
	        } else {
	            var ns = isSvg && name.match(/^xlink\:?(.+)/);
	            if (null == value || value === !1) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1])); else node.removeAttribute(name); else if ('object' != typeof value && !isFunction(value)) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1]), value); else node.setAttribute(name, value);
	        }
	    }
	    function setProperty(node, name, value) {
	        try {
	            node[name] = value;
	        } catch (e) {}
	    }
	    function eventProxy(e) {
	        return this._listeners[e.type](options.event && options.event(e) || e);
	    }
	    function collectNode(node) {
	        removeNode(node);
	        if (node instanceof Element) {
	            node._component = node._componentConstructor = null;
	            var _name = node.normalizedNodeName || toLowerCase(node.nodeName);
	            (nodes[_name] || (nodes[_name] = [])).push(node);
	        }
	    }
	    function createNode(nodeName, isSvg) {
	        var name = toLowerCase(nodeName), node = nodes[name] && nodes[name].pop() || (isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName));
	        node.normalizedNodeName = name;
	        return node;
	    }
	    function flushMounts() {
	        var c;
	        while (c = mounts.pop()) {
	            if (options.afterMount) options.afterMount(c);
	            if (c.componentDidMount) c.componentDidMount();
	        }
	    }
	    function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	        if (!diffLevel++) {
	            isSvgMode = parent && void 0 !== parent.ownerSVGElement;
	            hydrating = dom && !(ATTR_KEY in dom);
	        }
	        var ret = idiff(dom, vnode, context, mountAll);
	        if (parent && ret.parentNode !== parent) parent.appendChild(ret);
	        if (!--diffLevel) {
	            hydrating = !1;
	            if (!componentRoot) flushMounts();
	        }
	        return ret;
	    }
	    function idiff(dom, vnode, context, mountAll) {
	        var ref = vnode && vnode.attributes && vnode.attributes.ref;
	        while (isFunctionalComponent(vnode)) vnode = buildFunctionalComponent(vnode, context);
	        if (null == vnode) vnode = '';
	        if (isString(vnode)) {
	            if (dom && dom instanceof Text && dom.parentNode) {
	                if (dom.nodeValue != vnode) dom.nodeValue = vnode;
	            } else {
	                if (dom) recollectNodeTree(dom);
	                dom = document.createTextNode(vnode);
	            }
	            return dom;
	        }
	        if (isFunction(vnode.nodeName)) return buildComponentFromVNode(dom, vnode, context, mountAll);
	        var out = dom, nodeName = String(vnode.nodeName), prevSvgMode = isSvgMode, vchildren = vnode.children;
	        isSvgMode = 'svg' === nodeName ? !0 : 'foreignObject' === nodeName ? !1 : isSvgMode;
	        if (!dom) out = createNode(nodeName, isSvgMode); else if (!isNamedNode(dom, nodeName)) {
	            out = createNode(nodeName, isSvgMode);
	            while (dom.firstChild) out.appendChild(dom.firstChild);
	            if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	            recollectNodeTree(dom);
	        }
	        var fc = out.firstChild, props = out[ATTR_KEY];
	        if (!props) {
	            out[ATTR_KEY] = props = {};
	            for (var a = out.attributes, i = a.length; i--; ) props[a[i].name] = a[i].value;
	        }
	        if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && fc && fc instanceof Text && !fc.nextSibling) {
	            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
	        } else if (vchildren && vchildren.length || fc) innerDiffNode(out, vchildren, context, mountAll, !!props.dangerouslySetInnerHTML);
	        diffAttributes(out, vnode.attributes, props);
	        if (ref) (props.ref = ref)(out);
	        isSvgMode = prevSvgMode;
	        return out;
	    }
	    function innerDiffNode(dom, vchildren, context, mountAll, absorb) {
	        var j, c, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren && vchildren.length;
	        if (len) for (var i = 0; i < len; i++) {
	            var _child = originalChildren[i], props = _child[ATTR_KEY], key = vlen ? (c = _child._component) ? c.__key : props ? props.key : null : null;
	            if (null != key) {
	                keyedLen++;
	                keyed[key] = _child;
	            } else if (hydrating || absorb || props || _child instanceof Text) children[childrenLen++] = _child;
	        }
	        if (vlen) for (var i = 0; i < vlen; i++) {
	            vchild = vchildren[i];
	            child = null;
	            var key = vchild.key;
	            if (null != key) {
	                if (keyedLen && key in keyed) {
	                    child = keyed[key];
	                    keyed[key] = void 0;
	                    keyedLen--;
	                }
	            } else if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) {
	                c = children[j];
	                if (c && isSameNodeType(c, vchild)) {
	                    child = c;
	                    children[j] = void 0;
	                    if (j === childrenLen - 1) childrenLen--;
	                    if (j === min) min++;
	                    break;
	                }
	            }
	            child = idiff(child, vchild, context, mountAll);
	            if (child && child !== dom) if (i >= len) dom.appendChild(child); else if (child !== originalChildren[i]) {
	                if (child === originalChildren[i + 1]) removeNode(originalChildren[i]);
	                dom.insertBefore(child, originalChildren[i] || null);
	            }
	        }
	        if (keyedLen) for (var i in keyed) if (keyed[i]) recollectNodeTree(keyed[i]);
	        while (min <= childrenLen) {
	            child = children[childrenLen--];
	            if (child) recollectNodeTree(child);
	        }
	    }
	    function recollectNodeTree(node, unmountOnly) {
	        var component = node._component;
	        if (component) unmountComponent(component, !unmountOnly); else {
	            if (node[ATTR_KEY] && node[ATTR_KEY].ref) node[ATTR_KEY].ref(null);
	            if (!unmountOnly) collectNode(node);
	            var c;
	            while (c = node.lastChild) recollectNodeTree(c, unmountOnly);
	        }
	    }
	    function diffAttributes(dom, attrs, old) {
	        var name;
	        for (name in old) if (!(attrs && name in attrs) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
	        if (attrs) for (name in attrs) if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
	    }
	    function collectComponent(component) {
	        var name = component.constructor.name, list = components[name];
	        if (list) list.push(component); else components[name] = [ component ];
	    }
	    function createComponent(Ctor, props, context) {
	        var inst = new Ctor(props, context), list = components[Ctor.name];
	        Component.call(inst, props, context);
	        if (list) for (var i = list.length; i--; ) if (list[i].constructor === Ctor) {
	            inst.nextBase = list[i].nextBase;
	            list.splice(i, 1);
	            break;
	        }
	        return inst;
	    }
	    function setComponentProps(component, props, opts, context, mountAll) {
	        if (!component._disable) {
	            component._disable = !0;
	            if (component.__ref = props.ref) delete props.ref;
	            if (component.__key = props.key) delete props.key;
	            if (!component.base || mountAll) {
	                if (component.componentWillMount) component.componentWillMount();
	            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
	            if (context && context !== component.context) {
	                if (!component.prevContext) component.prevContext = component.context;
	                component.context = context;
	            }
	            if (!component.prevProps) component.prevProps = component.props;
	            component.props = props;
	            component._disable = !1;
	            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !component.base) renderComponent(component, 1, mountAll); else enqueueRender(component);
	            if (component.__ref) component.__ref(component);
	        }
	    }
	    function renderComponent(component, opts, mountAll, isChild) {
	        if (!component._disable) {
	            var skip, rendered, inst, cbase, props = component.props, state = component.state, context = component.context, previousProps = component.prevProps || props, previousState = component.prevState || state, previousContext = component.prevContext || context, isUpdate = component.base, nextBase = component.nextBase, initialBase = isUpdate || nextBase, initialChildComponent = component._component;
	            if (isUpdate) {
	                component.props = previousProps;
	                component.state = previousState;
	                component.context = previousContext;
	                if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
	                component.props = props;
	                component.state = state;
	                component.context = context;
	            }
	            component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	            component._dirty = !1;
	            if (!skip) {
	                if (component.render) rendered = component.render(props, state, context);
	                if (component.getChildContext) context = extend(clone(context), component.getChildContext());
	                while (isFunctionalComponent(rendered)) rendered = buildFunctionalComponent(rendered, context);
	                var toUnmount, base, childComponent = rendered && rendered.nodeName;
	                if (isFunction(childComponent)) {
	                    var childProps = getNodeProps(rendered);
	                    inst = initialChildComponent;
	                    if (inst && inst.constructor === childComponent && childProps.key == inst.__key) setComponentProps(inst, childProps, 1, context); else {
	                        toUnmount = inst;
	                        inst = createComponent(childComponent, childProps, context);
	                        inst.nextBase = inst.nextBase || nextBase;
	                        inst._parentComponent = component;
	                        component._component = inst;
	                        setComponentProps(inst, childProps, 0, context);
	                        renderComponent(inst, 1, mountAll, !0);
	                    }
	                    base = inst.base;
	                } else {
	                    cbase = initialBase;
	                    toUnmount = initialChildComponent;
	                    if (toUnmount) cbase = component._component = null;
	                    if (initialBase || 1 === opts) {
	                        if (cbase) cbase._component = null;
	                        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
	                    }
	                }
	                if (initialBase && base !== initialBase && inst !== initialChildComponent) {
	                    var baseParent = initialBase.parentNode;
	                    if (baseParent && base !== baseParent) {
	                        baseParent.replaceChild(base, initialBase);
	                        if (!toUnmount) {
	                            initialBase._component = null;
	                            recollectNodeTree(initialBase);
	                        }
	                    }
	                }
	                if (toUnmount) unmountComponent(toUnmount, base !== initialBase);
	                component.base = base;
	                if (base && !isChild) {
	                    var componentRef = component, t = component;
	                    while (t = t._parentComponent) (componentRef = t).base = base;
	                    base._component = componentRef;
	                    base._componentConstructor = componentRef.constructor;
	                }
	            }
	            if (!isUpdate || mountAll) mounts.unshift(component); else if (!skip) {
	                if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
	                if (options.afterUpdate) options.afterUpdate(component);
	            }
	            var fn, cb = component._renderCallbacks;
	            if (cb) while (fn = cb.pop()) fn.call(component);
	            if (!diffLevel && !isChild) flushMounts();
	        }
	    }
	    function buildComponentFromVNode(dom, vnode, context, mountAll) {
	        var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
	        while (c && !isOwner && (c = c._parentComponent)) isOwner = c.constructor === vnode.nodeName;
	        if (c && isOwner && (!mountAll || c._component)) {
	            setComponentProps(c, props, 3, context, mountAll);
	            dom = c.base;
	        } else {
	            if (originalComponent && !isDirectOwner) {
	                unmountComponent(originalComponent, !0);
	                dom = oldDom = null;
	            }
	            c = createComponent(vnode.nodeName, props, context);
	            if (dom && !c.nextBase) {
	                c.nextBase = dom;
	                oldDom = null;
	            }
	            setComponentProps(c, props, 1, context, mountAll);
	            dom = c.base;
	            if (oldDom && dom !== oldDom) {
	                oldDom._component = null;
	                recollectNodeTree(oldDom);
	            }
	        }
	        return dom;
	    }
	    function unmountComponent(component, remove) {
	        if (options.beforeUnmount) options.beforeUnmount(component);
	        var base = component.base;
	        component._disable = !0;
	        if (component.componentWillUnmount) component.componentWillUnmount();
	        component.base = null;
	        var inner = component._component;
	        if (inner) unmountComponent(inner, remove); else if (base) {
	            if (base[ATTR_KEY] && base[ATTR_KEY].ref) base[ATTR_KEY].ref(null);
	            component.nextBase = base;
	            if (remove) {
	                removeNode(base);
	                collectComponent(component);
	            }
	            var c;
	            while (c = base.lastChild) recollectNodeTree(c, !remove);
	        }
	        if (component.__ref) component.__ref(null);
	        if (component.componentDidUnmount) component.componentDidUnmount();
	    }
	    function Component(props, context) {
	        this._dirty = !0;
	        this.context = context;
	        this.props = props;
	        if (!this.state) this.state = {};
	    }
	    function render(vnode, parent, merge) {
	        return diff(merge, vnode, {}, !1, parent);
	    }
	    var options = {};
	    var stack = [];
	    var EMPTY_CHILDREN = [];
	    var lcCache = {};
	    var toLowerCase = function(s) {
	        return lcCache[s] || (lcCache[s] = s.toLowerCase());
	    };
	    var resolved = 'undefined' != typeof Promise && Promise.resolve();
	    var defer = resolved ? function(f) {
	        resolved.then(f);
	    } : setTimeout;
	    var EMPTY = {};
	    var ATTR_KEY = 'undefined' != typeof Symbol ? Symbol.for('preactattr') : '__preactattr_';
	    var NON_DIMENSION_PROPS = {
	        boxFlex: 1,
	        boxFlexGroup: 1,
	        columnCount: 1,
	        fillOpacity: 1,
	        flex: 1,
	        flexGrow: 1,
	        flexPositive: 1,
	        flexShrink: 1,
	        flexNegative: 1,
	        fontWeight: 1,
	        lineClamp: 1,
	        lineHeight: 1,
	        opacity: 1,
	        order: 1,
	        orphans: 1,
	        strokeOpacity: 1,
	        widows: 1,
	        zIndex: 1,
	        zoom: 1
	    };
	    var NON_BUBBLING_EVENTS = {
	        blur: 1,
	        error: 1,
	        focus: 1,
	        load: 1,
	        resize: 1,
	        scroll: 1
	    };
	    var items = [];
	    var nodes = {};
	    var mounts = [];
	    var diffLevel = 0;
	    var isSvgMode = !1;
	    var hydrating = !1;
	    var components = {};
	    extend(Component.prototype, {
	        linkState: function(key, eventPath) {
	            var c = this._linkedStates || (this._linkedStates = {});
	            return c[key + eventPath] || (c[key + eventPath] = createLinkedState(this, key, eventPath));
	        },
	        setState: function(state, callback) {
	            var s = this.state;
	            if (!this.prevState) this.prevState = clone(s);
	            extend(s, isFunction(state) ? state(s, this.props) : state);
	            if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
	            enqueueRender(this);
	        },
	        forceUpdate: function() {
	            renderComponent(this, 2);
	        },
	        render: function() {}
	    });
	    exports.h = h;
	    exports.cloneElement = cloneElement;
	    exports.Component = Component;
	    exports.render = render;
	    exports.rerender = rerender;
	    exports.options = options;
	});
	//# sourceMappingURL=preact.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global Node, Window */
	
	/**
	 * Select all matching elements on the page. Uses `document.querySelectorAll`.
	 *
	 * @param {String} el The CSS selector to search for.
	 * @param {Element} [context] The container to search within. Defaults to
	 * `document`.
	 * @returns {Element[]}
	 */
	function selectAll(el, context) {
	  // if `el` is a Node or Window, return it in an Array
	  if (el instanceof Node || el instanceof Window) return [el];
	
	  return Array.prototype.slice.call(typeof el === 'string' ? (context || document).querySelectorAll(el) : el || []);
	}
	
	exports.default = selectAll;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(29);
	var matches = __webpack_require__(9);
	
	/**
	 * Delegates the handling of events for an element matching a selector to an
	 * ancestor of the matching element.
	 * @param {Element} ancestor The ancestor element to add the listener to.
	 * @param {string} eventType The event type to listen to.
	 * @param {string} selector A CSS selector to match against child elements.
	 * @param {Function} callback A function to run any time the event happens.
	 * @param {Object} opts A configuration options object. The available options:
	 *     - useCapture<boolean>: If true, bind to the event capture phase.
	 *     - deep<boolean>: If true, delegate into shadow trees.
	 * @return {Object} The delegate object. It contains a destroy method.
	 */
	 module.exports = function delegate(
	    ancestor, eventType, selector, callback, opts) {
	
	  opts = opts || {};
	
	  // Defines the event listener.
	  var listener = function(event) {
	
	    // If opts.composed is true and the event originated from inside a Shadow
	    // tree, check the composed path nodes.
	    if (opts.composed && typeof event.composedPath == 'function') {
	      var composedPath = event.composedPath();
	      for (var i = 0, node; node = composedPath[i]; i++) {
	        if (node.nodeType == 1 && matches(node, selector)) {
	          delegateTarget = node;
	        }
	      }
	    }
	    // Otherwise check the parents.
	    else {
	      var delegateTarget = closest(event.target, selector, true);
	    }
	
	    if (delegateTarget) {
	      callback.call(delegateTarget, event, delegateTarget);
	    }
	  };
	
	  ancestor.addEventListener(eventType, listener, opts.useCapture);
	
	  return {
	    destroy: function() {
	      ancestor.removeEventListener(eventType, listener, opts.useCapture);
	    }
	  };
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var proto = window.Element.prototype;
	var nativeMatches = proto.matches ||
	    proto.matchesSelector ||
	    proto.webkitMatchesSelector ||
	    proto.mozMatchesSelector ||
	    proto.msMatchesSelector ||
	    proto.oMatchesSelector;
	
	
	/**
	 * Tests whether a DOM element matches a selector. This polyfills the native
	 * Element.prototype.matches method across browsers.
	 * @param {Element} element The DOM element to test.
	 * @param {string} selector The CSS selector to test element against.
	 * @return {boolean} True if the selector matches.
	 */
	 function matchesSelector(element, selector) {
	  if (typeof selector != 'string') return false;
	  if (nativeMatches) return nativeMatches.call(element, selector);
	  var nodes = element.parentNode.querySelectorAll(selector);
	  for (var i = 0, node; node = nodes[i]; i++) {
	    if (node == element) return true;
	  }
	  return false;
	}
	
	
	/**
	 * Tests if a DOM elements matches any of the test DOM elements or selectors.
	 * @param {Element} element The DOM element to test.
	 * @param {Element|string|Array<Element|String>} test A DOM element, a CSS
	 *     selector, or an array of DOM elements or CSS selectors to match against.
	 * @return {boolean} True of any part of the test matches.
	 */
	module.exports = function matches(element, test) {
	  // Validate input.
	  if (element && element.nodeType == 1 && test) {
	    // if test is a string or DOM element test it.
	    if (typeof test == 'string' || test.nodeType == 1) {
	      return element == test || matchesSelector(element, test);
	    }
	    // if it has a length property iterate over the items
	    // and return true if any match.
	    else if ('length' in test) {
	      for (var i = 0, item; item = test[i]; i++) {
	        if (element == item || matchesSelector(element, item)) return true;
	      }
	    }
	  }
	  // Still here? Return false
	  return false;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var HTTP_PORT = '80';
	var HTTPS_PORT = '443';
	var DEFAULT_PORT = RegExp(':(' + HTTP_PORT + '|' + HTTPS_PORT + ')$');
	
	
	var a = document.createElement('a');
	var cache = {};
	
	
	/**
	 * Parses the given url and returns an object mimicing a `Location` object.
	 * @param {string} url The url to parse.
	 * @return {Object} An object with the same properties as a `Location`
	 *    plus the convience properties `path` and `query`.
	 */
	module.exports = function parseUrl(url) {
	
	  // All falsy values (as well as ".") should map to the current URL.
	  url = (!url || url == '.') ? location.href : url;
	
	  if (cache[url]) return cache[url];
	
	  a.href = url;
	
	  // When parsing file relative paths (e.g. `../index.html`), IE will correctly
	  // resolve the `href` property but will keep the `..` in the `path` property.
	  // It will also not include the `host` or `hostname` properties. Furthermore,
	  // IE will sometimes return no protocol or just a colon, especially for things
	  // like relative protocol URLs (e.g. "//google.com").
	  // To workaround all of these issues, we reparse with the full URL from the
	  // `href` property.
	  if (url.charAt(0) == '.' || url.charAt(0) == '/') return parseUrl(a.href);
	
	  // Don't include default ports.
	  var port = (a.port == HTTP_PORT || a.port == HTTPS_PORT) ? '' : a.port;
	
	  // PhantomJS sets the port to "0" when using the file: protocol.
	  port = port == '0' ? '' : port;
	
	  // Sometimes IE incorrectly includes a port for default ports
	  // (e.g. `:80` or `:443`) even when no port is specified in the URL.
	  // http://bit.ly/1rQNoMg
	  var host = a.host.replace(DEFAULT_PORT, '');
	
	  // Not all browser support `origin` so we have to build it.
	  var origin = a.origin ? a.origin : a.protocol + '//' + host;
	
	  // Sometimes IE doesn't include the leading slash for pathname.
	  // http://bit.ly/1rQNoMg
	  var pathname = a.pathname.charAt(0) == '/' ? a.pathname : '/' + a.pathname;
	
	  return cache[url] = {
	    hash: a.hash,
	    host: host,
	    hostname: a.hostname,
	    href: a.href,
	    origin: origin,
	    pathname: pathname,
	    port: port,
	    protocol: a.protocol,
	    search: a.search,
	
	    // Expose additional helpful properties not part of the Location object.
	    fragment: a.hash.slice(1), // The hash without the starting "#".
	    path: pathname + a.search, // The pathname and the search query (w/o hash).
	    query: a.search.slice(1) // The search without the starting "?".
	  };
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(2);
	var parseUrl = __webpack_require__(10);
	var constants = __webpack_require__(5);
	var provide = __webpack_require__(3);
	var usage = __webpack_require__(4);
	
	
	/**
	 * Registers clean URL tracking on a tracker object. The clean URL tracker
	 * removes query parameters from the page value reported to Google Analytics.
	 * It also helps to prevent tracking similar URLs, e.g. sometimes ending a URL
	 * with a slash and sometimes not.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function CleanUrlTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.CLEAN_URL_TRACKER);
	
	  this.opts = assign({
	    stripQuery: false,
	    queryDimensionIndex: null,
	    indexFilename: null,
	    trailingSlash: null
	  }, opts);
	
	  this.tracker = tracker;
	
	  this.overrideTrackerBuildHitTask();
	}
	
	
	/**
	 * Cleans the URL based on the preferences set in the configuration options.
	 * @param {Object} model An analytics.js Model object.
	 */
	CleanUrlTracker.prototype.cleanUrlTask = function(model) {
	
	  var location = model.get('location');
	  var page = model.get('page');
	  var url = parseUrl(page || location);
	
	  var oldPath = url.pathname;
	  var newPath = oldPath;
	
	  // If an index filename was provided, remove it if it appears at the end
	  // of the URL.
	  if (this.opts.indexFilename) {
	    var parts = newPath.split('/');
	    if (this.opts.indexFilename == parts[parts.length - 1]) {
	      parts[parts.length - 1] = '';
	      newPath = parts.join('/');
	    }
	  }
	
	  // Ensure the URL ends with or doesn't end with slash based on the
	  // `trailingSlash` option. Note that filename URLs should never contain
	  // a trailing slash.
	  if (this.opts.trailingSlash == 'remove') {
	      newPath = newPath.replace(/\/+$/, '');
	  }
	  else if (this.opts.trailingSlash == 'add') {
	    var isFilename = /\.\w+$/.test(newPath);
	    if (!isFilename && newPath.substr(-1) != '/') {
	      newPath = newPath + '/';
	    }
	  }
	
	  // If a query dimensions index was provided, set the query string portion
	  // of the URL on that dimension. If no query string exists on the URL use
	  // the NULL_DIMENSION.
	  if (this.opts.stripQuery && this.opts.queryDimensionIndex) {
	    model.set('dimension' + this.opts.queryDimensionIndex,
	        url.query || constants.NULL_DIMENSION);
	  }
	
	  model.set('page', newPath + (!this.opts.stripQuery ? url.search : ''));
	};
	
	
	/**
	 * Overrides the tracker's `buildHitTask` to check for proper URL formatting
	 * on every hit (not just the initial pageview).
	 */
	CleanUrlTracker.prototype.overrideTrackerBuildHitTask = function() {
	  this.originalTrackerBuildHitTask = this.tracker.get('buildHitTask');
	
	  this.tracker.set('buildHitTask', function(model) {
	    this.cleanUrlTask(model);
	    this.originalTrackerBuildHitTask(model);
	  }.bind(this));
	};
	
	
	/**
	 * Restores all overridden tasks and methods.
	 */
	CleanUrlTracker.prototype.remove = function() {
	  this.tracker.set('sendHitTask', this.originalTrackerSendHitTask);
	};
	
	
	provide('cleanUrlTracker', CleanUrlTracker);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(2);
	var delegate = __webpack_require__(8);
	var provide = __webpack_require__(3);
	var usage = __webpack_require__(4);
	var createFieldsObj = __webpack_require__(1).createFieldsObj;
	var getAttributeFields = __webpack_require__(1).getAttributeFields;
	
	
	/**
	 * Registers declarative event tracking.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function EventTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.EVENT_TRACKER);
	
	  // Feature detects to prevent errors in unsupporting browsers.
	  if (!window.addEventListener) return;
	
	  this.opts = assign({
	    events: ['click'],
	    fieldsObj: {},
	    attributePrefix: 'ga-',
	    hitFilter: null
	  }, opts);
	
	  this.tracker = tracker;
	
	  // Binds methods.
	  this.handleEvents = this.handleEvents.bind(this);
	
	  var selector = '[' + this.opts.attributePrefix + 'on]';
	
	  // Creates a mapping of events to their delegates
	  this.delegates = {};
	  this.opts.events.forEach(function(event) {
	    this.delegates[event] = delegate(document, event, selector,
	        this.handleEvents, {composed: true, useCapture: true});
	  }.bind(this));
	}
	
	
	/**
	 * Handles all clicks on elements with event attributes.
	 * @param {Event} event The DOM click event.
	 * @param {Element} element The delegated DOM element target.
	 */
	EventTracker.prototype.handleEvents = function(event, element) {
	
	  var prefix = this.opts.attributePrefix;
	
	  // Ensures the event type matches the one specified on the element.
	  if (event.type != element.getAttribute(prefix + 'on')) return;
	
	  var defaultFields = {transport: 'beacon'};
	  var attributeFields = getAttributeFields(element, prefix);
	  var userFields = assign({}, this.opts.fieldsObj, attributeFields);
	  var hitType = attributeFields.hitType || 'event';
	
	  this.tracker.send(hitType, createFieldsObj(
	      defaultFields, userFields, this.tracker, this.opts.hitFilter, element));
	};
	
	
	/**
	 * Removes all event listeners and instance properties.
	 */
	EventTracker.prototype.remove = function() {
	  Object.keys(this.delegates).forEach(function(key) {
	    this.delegates[key].destroy();
	  }.bind(this));
	};
	
	
	provide('eventTracker', EventTracker);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(2);
	var delegate = __webpack_require__(8);
	var parseUrl = __webpack_require__(10);
	var provide = __webpack_require__(3);
	var usage = __webpack_require__(4);
	var createFieldsObj = __webpack_require__(1).createFieldsObj;
	var getAttributeFields = __webpack_require__(1).getAttributeFields;
	
	
	/**
	 * Registers outbound link tracking on a tracker object.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function OutboundLinkTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.OUTBOUND_LINK_TRACKER);
	
	  // Feature detects to prevent errors in unsupporting browsers.
	  if (!window.addEventListener) return;
	
	  this.opts = assign({
	    events: ['click'],
	    linkSelector: 'a, area',
	    shouldTrackOutboundLink: this.shouldTrackOutboundLink,
	    fieldsObj: {},
	    attributePrefix: 'ga-',
	    hitFilter: null
	  }, opts);
	
	  this.tracker = tracker;
	
	  // Binds methods.
	  this.handleLinkInteractions = this.handleLinkInteractions.bind(this);
	
	  // Creates a mapping of events to their delegates
	  this.delegates = {};
	  this.opts.events.forEach(function(event) {
	    this.delegates[event] = delegate(document, event, this.opts.linkSelector,
	        this.handleLinkInteractions, {composed: true, useCapture: true});
	  }.bind(this));
	}
	
	
	/**
	 * Handles all interactions on link elements. A link is considered an outbound
	 * link if its hostname property does not match location.hostname. When the
	 * beacon transport method is not available, the links target is set to
	 * "_blank" to ensure the hit can be sent.
	 * @param {Event} event The DOM click event.
	 * @param {Element} link The delegated event target.
	 */
	OutboundLinkTracker.prototype.handleLinkInteractions = function(event, link) {
	
	  if (this.opts.shouldTrackOutboundLink(link, parseUrl)) {
	    // Opens outbound links in a new tab if the browser doesn't support
	    // the beacon transport method.
	    if (!navigator.sendBeacon) {
	      link.target = '_blank';
	    }
	
	    var href = link.getAttribute('href') || link.getAttribute('xlink:href');
	    var url = parseUrl(href);
	
	    var defaultFields = {
	      transport: 'beacon',
	      eventCategory: 'Outbound Link',
	      eventAction: event.type,
	      eventLabel: url.href
	    };
	
	    var userFields = assign({}, this.opts.fieldsObj,
	        getAttributeFields(link, this.opts.attributePrefix));
	
	    this.tracker.send('event', createFieldsObj(
	        defaultFields, userFields, this.tracker, this.opts.hitFilter, link));
	  }
	};
	
	
	/**
	 * Determines whether or not the tracker should send a hit when a link is
	 * clicked. By default links with a hostname property not equal to the current
	 * hostname are tracked.
	 * @param {Element} link The link that was clicked on.
	 * @param {Function} parseUrl A cross-browser utility method for url parsing.
	 * @return {boolean} Whether or not the link should be tracked.
	 */
	OutboundLinkTracker.prototype.shouldTrackOutboundLink =
	    function(link, parseUrl) {
	
	  var href = link.getAttribute('href') || link.getAttribute('xlink:href');
	  var url = parseUrl(href);
	  return url.hostname != location.hostname &&
	      url.protocol.slice(0, 4) == 'http';
	};
	
	
	/**
	 * Removes all event listeners and instance properties.
	 */
	OutboundLinkTracker.prototype.remove = function() {
	  Object.keys(this.delegates).forEach(function(key) {
	    this.delegates[key].destroy();
	  }.bind(this));
	};
	
	
	provide('outboundLinkTracker', OutboundLinkTracker);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(2);
	var provide = __webpack_require__(3);
	var usage = __webpack_require__(4);
	var createFieldsObj = __webpack_require__(1).createFieldsObj;
	var isObject = __webpack_require__(1).isObject;
	
	
	var DEFAULT_SESSION_TIMEOUT = 30; // 30 minutes.
	
	
	/**
	 * Registers outbound link tracking on tracker object.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function PageVisibilityTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.PAGE_VISIBILITY_TRACKER);
	
	  // Feature detects to prevent errors in unsupporting browsers.
	  if (!window.addEventListener) return;
	
	  this.opts = assign({
	    sessionTimeout: DEFAULT_SESSION_TIMEOUT,
	    changeTemplate: this.changeTemplate,
	    hiddenMetricIndex: null,
	    visibleMetricIndex: null,
	    fieldsObj: {},
	    hitFilter: null
	  }, opts);
	
	  this.tracker = tracker;
	  this.visibilityState = document.visibilityState;
	
	  // Consider the plugin creation to be the start of the visibility change
	  // time calculations.
	  this.lastVisibilityChangeTime = +new Date;
	
	  // Binds methods to `this`.
	  this.handleVisibilityStateChange =
	      this.handleVisibilityStateChange.bind(this);
	
	  this.overrideTrackerSendMethod();
	  this.overrideTrackerSendHitTask();
	
	  document.addEventListener(
	      'visibilitychange', this.handleVisibilityStateChange);
	}
	
	
	/**
	 * Handles changes to `document.visibilityState`. This method sends events when
	 * the visibility state changes during active sessions (active meaning the
	 * session has not timed out). If the session has timed out, a return to a
	 * visibility state of visible will trigger a new pageview (instead of a
	 * visibility change event). Lastly, this method keeps track of the elapsed
	 * time a document's visibility state was visible and sends that as the event
	 * value for hidden events, allowing you to more accurately derive how long
	 * a user spent active during a session.
	 */
	PageVisibilityTracker.prototype.handleVisibilityStateChange = function() {
	
	  var defaultFields;
	  this.prevVisibilityState = this.visibilityState;
	  this.visibilityState = document.visibilityState;
	
	  if (this.sessionHasTimedOut()) {
	    // Prevents sending 'hidden' state hits when the session has timed out.
	    if (this.visibilityState == 'hidden') return;
	
	    if (this.visibilityState == 'visible') {
	      // If the session has timed out, a transition to "visible" should be
	      // considered a new pageview and a new session.
	      defaultFields = {transport: 'beacon'};
	      this.tracker.send('pageview', createFieldsObj(defaultFields,
	          this.opts.fieldsObj, this.tracker, this.opts.hitFilter));
	    }
	  }
	  else {
	    // Rounds the time up to the nearest second. If the rounded value is zero
	    // use 1 instead since unset metrics default to 0.
	    var timeDeltaInSeconds = Math.round(
	        (new Date - this.lastVisibilityChangeTime) / 1000) || 1;
	
	    defaultFields = {
	      transport: 'beacon',
	      eventCategory: 'Page Visibility',
	      eventAction: 'change',
	      eventLabel: this.opts.changeTemplate(
	          this.prevVisibilityState, this.visibilityState),
	      eventValue: timeDeltaInSeconds
	    };
	
	    // Changes to hidden are non interaction hits by default
	    if (this.visibilityState == 'hidden') defaultFields.nonInteraction = true;
	
	    // If a custom metric was specified for the current visibility state,
	    // give it the same as the event value.
	    var metric = this.opts[this.prevVisibilityState + 'MetricIndex'];
	    if (metric) defaultFields['metric' + metric] = timeDeltaInSeconds;
	
	    this.tracker.send('event', createFieldsObj(defaultFields,
	        this.opts.fieldsObj, this.tracker, this.opts.hitFilter));
	  }
	
	  // Updates the time the last visibility state change event occurred, so
	  // change events can report the delta.
	  this.lastVisibilityChangeTime = +new Date;
	};
	
	
	/**
	 * Returns true if the session has not timed out. A session timeout occurs when
	 * more than `this.opts.sessionTimeout` minutes has elapsed since the
	 * tracker sent the previous hit.
	 * @return {boolean} True if the session has timed out.
	 */
	PageVisibilityTracker.prototype.sessionHasTimedOut = function() {
	  var minutesSinceLastHit = (new Date - this.lastHitTime) / (60 * 1000);
	  return this.opts.sessionTimeout < minutesSinceLastHit;
	};
	
	
	/**
	 * Overrides the `tracker.send` method to send a pageview hit before the
	 * current hit being sent if the session has timed out and the current hit is
	 * not a pageview itself.
	 */
	PageVisibilityTracker.prototype.overrideTrackerSendMethod = function() {
	  this.originalTrackerSendMethod = this.tracker.send;
	
	  this.tracker.send = function() {
	    var args = Array.prototype.slice.call(arguments);
	    var firstArg = args[0];
	    var hitType = isObject(firstArg) ? firstArg.hitType : firstArg;
	    var isPageview = hitType == 'pageview';
	
	    if (!isPageview && this.sessionHasTimedOut()) {
	      var defaultFields = {transport: 'beacon'};
	      this.originalTrackerSendMethod.call(this.tracker, 'pageview',
	          createFieldsObj(defaultFields, this.opts.fieldsObj,
	              this.tracker, this.opts.hitFilter));
	    }
	
	    this.originalTrackerSendMethod.apply(this.tracker, args);
	  }.bind(this);
	};
	
	
	/**
	 * Overrides the tracker's `sendHitTask` to record the time of the previous
	 * hit. This is used to determine whether or not a session has timed out.
	 */
	PageVisibilityTracker.prototype.overrideTrackerSendHitTask = function() {
	  this.originalTrackerSendHitTask = this.tracker.get('sendHitTask');
	  this.lastHitTime = +new Date;
	
	  this.tracker.set('sendHitTask', function(model) {
	    this.originalTrackerSendHitTask(model);
	    this.lastHitTime = +new Date;
	  }.bind(this));
	};
	
	
	/**
	 * Sets the default formatting of the change event label.
	 * This can be overridden by setting the `changeTemplate` option.
	 * @param {string} oldValue The value of the media query prior to the change.
	 * @param {string} newValue The value of the media query after the change.
	 * @return {string} The formatted event label.
	 */
	PageVisibilityTracker.prototype.changeTemplate = function(oldValue, newValue) {
	  return oldValue + ' => ' + newValue;
	};
	
	
	/**
	 * Removes all event listeners and instance properties.
	 */
	 PageVisibilityTracker.prototype.remove = function() {
	  this.tracker.set('sendHitTask', this.originalTrackerSendHitTask);
	  this.tracker.send = this.originalTrackerSendMethod;
	
	  document.removeEventListener(
	      'visibilitychange', this.handleVisibilityStateChange);
	};
	
	
	provide('pageVisibilityTracker', PageVisibilityTracker);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(6);
	
	var _get = __webpack_require__(22);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _story = __webpack_require__(17);
	
	var _story2 = _interopRequireDefault(_story);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedStories = function (_Component) {
	  _inherits(RelatedStories, _Component);
	
	  function RelatedStories() {
	    _classCallCheck(this, RelatedStories);
	
	    var _this = _possibleConstructorReturn(this, (RelatedStories.__proto__ || Object.getPrototypeOf(RelatedStories)).call(this));
	
	    _this.state = {
	      stories: []
	    };
	    return _this;
	  }
	
	  _createClass(RelatedStories, [{
	    key: 'loadStories',
	    value: function loadStories() {
	      var _this2 = this;
	
	      var tag = this.props.tag;
	      var src = 'https://www.texastribune.org/api/content/?content_type=story,audio,video,pointer&tag=' + tag + '&fields=id,url,readable_pub_date,seo_headline,short_summary,lead_art&limit=4&format=json';
	
	      (0, _get2.default)(src).then(JSON.parse).then(function (_ref) {
	        var results = _ref.results;
	
	        _this2.setState({ stories: results });
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadStories();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var stories = this.state.stories;
	      var isColumn = this.props.isColumn;
	      var title = this.props.title;
	
	      var renderedStories = stories.map(function (story) {
	        return (0, _preact.h)(_story2.default, story);
	      });
	
	      return (0, _preact.h)(
	        'div',
	        { 'class': 'related-stories' + (isColumn ? ' related-stories--column' : '') },
	        title && (0, _preact.h)(
	          'h3',
	          { 'class': 'section-sub-header' },
	          title
	        ),
	        renderedStories
	      );
	    }
	  }]);
	
	  return RelatedStories;
	}(_preact.Component);
	
	exports.default = RelatedStories;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preact = __webpack_require__(6);
	
	var Story = function Story(_ref) {
	  var seo_headline = _ref.seo_headline,
	      short_summary = _ref.short_summary,
	      url = _ref.url,
	      lead_art = _ref.lead_art,
	      readable_pub_date = _ref.readable_pub_date;
	
	  return (0, _preact.h)(
	    "article",
	    { "class": "story" },
	    (0, _preact.h)(
	      "a",
	      { "class": "story-link dim", href: url },
	      (0, _preact.h)(
	        "div",
	        { "class": "story-media" },
	        (0, _preact.h)(
	          "div",
	          { "class": "story-art" },
	          (0, _preact.h)("img", { src: lead_art.thumbnails.letterbox })
	        ),
	        (0, _preact.h)(
	          "div",
	          { "class": "story-text" },
	          (0, _preact.h)(
	            "header",
	            { "class": "story-header" },
	            (0, _preact.h)(
	              "h4",
	              { "class": "story-headline" },
	              seo_headline
	            ),
	            (0, _preact.h)(
	              "p",
	              { "class": "story-byline" },
	              readable_pub_date
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Story;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getMatchingAttributes = __webpack_require__(21);
	
	var _getMatchingAttributes2 = _interopRequireDefault(_getMatchingAttributes);
	
	var _loadScript = __webpack_require__(23);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _objectAssign = __webpack_require__(24);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _selectAll = __webpack_require__(7);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _uniqueId = __webpack_require__(28);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AdLoader
	 *
	 * @param  {Object} opts
	 * @return {Object}
	 */
	function AdLoader(opts) {
	  var w = window;
	  var hasBeenInit = false;
	  var adSlots;
	
	  var defaultOpts = {
	    attributePrefix: 'dv-gpt-',
	    defaultAdFields: {
	      adUnit: '/5805113/basic',
	      dimensions: [300, 250]
	    },
	    globalMappings: {
	      banner: [[[768, 130], [[728, 90]]]],
	      smallBanner: [[[508, 100], [[468, 60]]]]
	    },
	    gptSrc: 'https://www.googletagservices.com/tag/js/gpt.js',
	    idPrefix: 'dv-gpt-',
	    selector: '.dv-gpt-ad',
	    targetingKey: 'tribpedia',
	    targetingValue: null
	  };
	
	  opts = (0, _objectAssign2.default)({}, defaultOpts, opts);
	
	  var adElements = (0, _selectAll2.default)(opts.selector);
	
	  function setupService() {
	    w.googletag.cmd.push(function () {
	      var pubads = w.googletag.pubads();
	
	      if (opts.targetingKey && opts.targetingValue) {
	        pubads.setTargeting(opts.targetingKey, opts.targetingValue);
	      }
	
	      pubads.enableSingleRequest();
	      w.googletag.enableServices();
	    });
	  }
	
	  function createAds() {
	    adSlots = adElements.map(function (element) {
	      var matchingAttributes = (0, _getMatchingAttributes2.default)(element, opts.attributePrefix);
	      var localOpts = (0, _objectAssign2.default)({}, opts.defaultAdFields, matchingAttributes);
	
	      var adElementId = (0, _uniqueId2.default)(opts.idPrefix);
	      element.setAttribute('id', adElementId);
	
	      var adUnit = w.googletag.defineSlot(localOpts.adUnit, localOpts.dimensions, adElementId);
	
	      if (localOpts.mapping && opts.globalMappings.hasOwnProperty(localOpts.mapping)) {
	        adUnit.defineSizeMapping(opts.globalMappings[localOpts.mapping]);
	      }
	
	      if (localOpts.targetingKey && localOpts.targetingValue) {
	        adUnit.setTargeting(localOpts.targetingKey, localOpts.targetingValue);
	      }
	
	      adUnit.setCollapseEmptyDiv(true);
	      adUnit.addService(w.googletag.pubads());
	
	      w.googletag.display(adElementId);
	
	      return adUnit;
	    });
	  }
	
	  function init() {
	    if (hasBeenInit) return;
	
	    (0, _loadScript2.default)(opts.gptSrc, function () {
	      w.googletag.cmd.push(setupService, createAds);
	
	      hasBeenInit = true;
	    });
	  }
	
	  return {
	    adSlots: adSlots,
	    init: init
	  };
	}
	
	exports.default = AdLoader;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelCase;
	/**
	 * Converts a string from dash or underscore separated to camelCase.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	function camelCase(str) {
	  // remove any dashes or underscores in the string, and grab the following character
	  return str.replace(/[-_]+(\w?)/g, function (match, p1) {
	    // uppercase the following letter
	    return p1.toUpperCase();
	  });
	}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getAttributes;
	/**
	 * Gets all the attributes set on an element, and returns them as an Object.
	 *
	 * @param  {Element} element
	 * @return {Object}
	 */
	function getAttributes(element) {
	  var attrs = {};
	
	  // if element is empty, or not ELEMENT_NODE, eject
	  if (!element || element.nodeType !== 1) return attrs;
	
	  // grab all the attributes off the element
	  var map = element.attributes;
	
	  // if there are no attributes, eject
	  if (map.length === 0) return attrs;
	
	  // loop through the attributes and build the object
	  for (var i = 0; i < map.length; i++) {
	    attrs[map[i].name] = map[i].value;
	  }
	
	  return attrs;
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMatchingAttributes;
	
	var _camelCase = __webpack_require__(19);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _getAttributes = __webpack_require__(20);
	
	var _getAttributes2 = _interopRequireDefault(_getAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Searches an element's attributes and returns an Object of all the ones that
	 * begin with a specified prefix. Each matching attribute name is returned
	 * without the prefix, with the remainder converted to camelCase.
	 *
	 * @param  {Element} element
	 * @param  {String} prefix
	 * @return {Object}
	 */
	function getMatchingAttributes(element, prefix) {
	  // get all the attributes on the element
	  var attributes = (0, _getAttributes2.default)(element);
	  var fields = {};
	
	  // loop through the keys of the attributes
	  Object.keys(attributes).forEach(function (key) {
	    // continue if the key begins with supplied prefix
	    if (key.substr(0, prefix.length) === prefix) {
	      // grab the value associated with the original key
	      var value = attributes[key];
	
	      // slice off the prefix and camelCase what is left
	      var field = (0, _camelCase2.default)(key.slice(prefix.length));
	
	      fields[field] = value;
	    }
	  });
	
	  return fields;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = get;
	
	var _promise = __webpack_require__(25);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A very simple Promise-based wrapper around XMLHttpRequest.
	 *
	 * If you are polyfilling fetch or using jQuery.ajax for nothing more than a
	 * simple GET request, use this instead to save a bunch of bytes.
	 *
	 * @param  {String} url
	 * @return {Promise}
	 * @example
	 *
	 * get('assets/data.json').then(function (data) {
	 *   // `data` contains the contents the file at path
	 * });
	 */
	function get(url) {
	  return new _promise2.default(function dispatchXMLHttpRequest(resolve, reject) {
	    var req = new window.XMLHttpRequest();
	    req.open('GET', url, true);
	
	    req.onload = function () {
	      var status = req.status;
	
	      if (status >= 200 && status < 300) {
	        resolve(req.response);
	      } else {
	        reject(new Error('Request failed: ' + status));
	      }
	    };
	
	    req.onerror = reject;
	
	    req.send(null);
	  });
	}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = loadScript;
	/**
	 * A helper for asynchronously loading scripts.
	 *
	 * Provides a callback interface for passing a function that will only be
	 * called if the script is successfully added to the page.
	 *
	 * @param {String} url The URL for the script to be loaded.
	 * @param {Function} [callback] A function to be called once the script
	 * successfully loads. Not required.
	 * @param {Function} [errorCallback] A function to be called if the script
	 * unsuccessfully loads. Not required.
	 * @returns {void}
	 * @example
	 *
	 * loadScript('backup.js', function () {
	 *   // anything that depends on that script loading
	 * })
	 */
	function loadScript(url, callback, errorCallback) {
	  var script = document.createElement('script');
	  script.src = url;
	
	  if (callback) script.onload = callback;
	  if (errorCallback) script.onerror = errorCallback;
	
	  document.body.appendChild(script);
	}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var objectAssign = Object.assign || function objectAssign(target, varArgs) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	
	  for (var idx = 1; idx < arguments.length; idx++) {
	    var source = arguments[idx];
	
	    if (source != null) {
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          output[key] = source[key];
	        }
	      }
	    }
	  }
	
	  return output;
	};
	
	exports.default = objectAssign;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Extensions = __webpack_require__(33);
	
	var _es6Extensions2 = _interopRequireDefault(_es6Extensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Promise = window.Promise || _es6Extensions2.default;
	
	exports.default = Promise;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Select an element on the page. Uses `document.querySelector`, meaning it
	 * will only return the first element that matches.
	 *
	 * @param {String} el The CSS selector to search for.
	 * @param {Element} [context] The container to search within. Defaults to
	 * `document`.
	 * @returns {Element|null}
	 */
	function select(el, context) {
	  return typeof el === 'string' ? (context || document).querySelector(el) : el || null;
	}
	
	exports.default = select;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	/* global ga */
	
	ga('require', 'cleanUrlTracker', {
	  indexFilename: 'index.html',
	  queryDimensionIndex: 1,
	  stripQuery: true,
	  trailingSlash: 'add'
	});
	
	ga('require', 'eventTracker');
	
	ga('require', 'outboundLinkTracker');
	
	// ga('require', 'pageVisibilityTracker', {
	//   fieldsObj: {
	//     nonInteraction: null
	//   }
	// });

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uniqueId;
	// Borrowed from underscore.js: http://underscorejs.org/#uniqueId
	/**
	 * Counter used by {uniqueId} to iterate.
	 * @private
	 * @type {Number}
	 */
	var idCounter = 0;
	
	/**
	 * Generates identifiers unique to a single browser session. Each time it runs,
	 * the integer at the end of the return value will increment.
	 *
	 * @param  {String} [prefix] Optional prefix for identifier
	 * @return {String}
	 * @example
	 *
	 * var identifier = uniqueId();
	 * // returns '1'
	 *
	 * var prefixedIdentifier = uniqueId('label-');
	 * // returns 'label-2'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter + '';
	  return prefix ? prefix + id : id;
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var matches = __webpack_require__(9);
	var parents = __webpack_require__(31);
	
	/**
	 * Gets the closest parent element that matches the passed selector.
	 * @param {Element} element The element whose parents to check.
	 * @param {string} selector The CSS selector to match against.
	 * @param {boolean} shouldCheckSelf True if the selector should test against
	 *     the passed element itself.
	 * @return {?Element} The matching element or undefined.
	 */
	module.exports = function closest(element, selector, shouldCheckSelf) {
	  if (!(element && element.nodeType == 1 && selector)) return;
	
	  var parentElements =
	      (shouldCheckSelf ? [element] : []).concat(parents(element));
	
	  for (var i = 0, parent; parent = parentElements[i]; i++) {
	    if (matches(parent, selector)) return parent;
	  }
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Gets all attributes of an element as a plain JavaScriot object.
	 * @param {Element} element The element whose attributes to get.
	 * @return {Object} An object whose keys are the attribute keys and whose
	 *     values are the attribute values. If no attributes exist, an empty
	 *     object is returned.
	 */
	module.exports = function getAttributes(element) {
	  var attrs = {};
	
	  // Validate input.
	  if (!(element && element.nodeType == 1)) return attrs;
	
	  // Return an empty object if there are no attributes.
	  var map = element.attributes;
	  if (map.length === 0) return {};
	
	  for (var i = 0, attr; attr = map[i]; i++) {
	    attrs[attr.name] = attr.value;
	  }
	  return attrs;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	 * Returns an array of a DOM element's parent elements.
	 * @param {Element} element The DOM element whose parents to get.
	 * @return {Array} An array of all parent elemets, or an empty array if no
	 *     parent elements are found.
	 */
	module.exports = function parents(element) {
	  var list = [];
	  while (element && element.parentNode && element.parentNode.nodeType == 1) {
	    list.push(element = element.parentNode);
	  }
	  return list;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(11);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('Promise constructor\'s argument is not a function');
	  }
	  this._40 = 0;
	  this._65 = 0;
	  this._55 = null;
	  this._72 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._37 = null;
	Promise._87 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	}
	function handle(self, deferred) {
	  while (self._65 === 3) {
	    self = self._55;
	  }
	  if (Promise._37) {
	    Promise._37(self);
	  }
	  if (self._65 === 0) {
	    if (self._40 === 0) {
	      self._40 = 1;
	      self._72 = deferred;
	      return;
	    }
	    if (self._40 === 1) {
	      self._40 = 2;
	      self._72 = [self._72, deferred];
	      return;
	    }
	    self._72.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._65 === 1) {
	        resolve(deferred.promise, self._55);
	      } else {
	        reject(deferred.promise, self._55);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._55);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._65 = 3;
	      self._55 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._65 = 1;
	  self._55 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._65 = 2;
	  self._55 = newValue;
	  if (Promise._87) {
	    Promise._87(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._40 === 1) {
	    handle(self, self._72);
	    self._72 = null;
	  }
	  if (self._40 === 2) {
	    for (var i = 0; i < self._72.length; i++) {
	      handle(self, self._72[i]);
	    }
	    self._72 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(32);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._65 = 1;
	  p._55 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._65 === 3) {
	            val = val._55;
	          }
	          if (val._65 === 1) return res(i, val._55);
	          if (val._65 === 2) reject(val._55);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js